import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
import {preinit} from 'react-dom';
preinit(parcelRequire.resolve("igRYP"), {as: 'style', precedence: 'default'});
let promise = Promise.all([parcelRequire.load("awzdE"), parcelRequire.load("kWrGa"), parcelRequire.load("fqSlw"), parcelRequire.load("hHkzJ"), parcelRequire.load("lo1tk"), parcelRequire.load("373ut"), parcelRequire.load("68Spg"), parcelRequire.load("blC0m")]).then(() => {
let originalModule = parcelRequire("7ohac");
let resources = <>
  <link rel="modulepreload" href={parcelRequire.resolve("awzdE")} />
  <link rel="stylesheet" href={parcelRequire.resolve("igRYP")} precedence="default" />
  <link rel="modulepreload" href={parcelRequire.resolve("kWrGa")} />
  <link rel="modulepreload" href={parcelRequire.resolve("fqSlw")} />
  <link rel="modulepreload" href={parcelRequire.resolve("hHkzJ")} />
  <link rel="modulepreload" href={parcelRequire.resolve("lo1tk")} />
  <link rel="modulepreload" href={parcelRequire.resolve("373ut")} />
  <link rel="modulepreload" href={parcelRequire.resolve("68Spg")} />
  <link rel="modulepreload" href={parcelRequire.resolve("blC0m")} />
</>;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
